//import "../../assets/ReportViewer/js/telerikReportViewer-13.0.19.222";
import "../../assets/ReportViewer/js/telerikReportViewer-14.0.20.219";

import router from "vue-router";
export default {
  name: "ReportViewer",
  props: {
    parameter: {
      type: Object,
    },
    groupTitle: {
      type: String,
      default: () => {
        return "";
      },
    },
    isGrouped: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    reports: {
      type: Array | Object,
      default: () => {
        return [];
      },
    },
    overrideParameters: {
      type: Boolean,
    },
  },

  data() {
    return {
      currentReport: {},
      // reports: [],
      // overrideParameters: false,
      // isGrouped: false,
      // groupTitle: "",
      // parameter: "",
    };
  },
  // created() {
  //   debugger;
  //   var telerikParams = localStorage.getItem("telerikParameters");
  //   if (telerikParams) {
  //     Object.assign(this.$data, JSON.parse(telerikParams));
  //   }
  // },
  mounted() {
    debugger;
    if (!this.isGrouped && this.reports) {
      this.selectReport(this.reports.url);
    } else {
      this.currentReport = this.reports[0];
      this.selectReport(this.reports[0].url);
    }
  },
  methods: {
    selectReport(reportUrl) {
      let context = this;

      var reportViewer = $("#reportViewer1").data("telerik_ReportViewer");
      if (reportViewer) {
        reportViewer.reportSource({
          report: reportUrl,
          parameters: context.parameter,
        });
      } else {
        this.LoadReportViewer(reportUrl);
      }
    },
    LoadReportViewer(reportUrl) {
      let context = this;
      this.$nextTick(function() {
        $("#reportViewer1").telerik_ReportViewer({
          // serviceUrl: "http://13.91.248.137:8080/api/reports",
          reportServer: {
            url: "https://reports.lbcnam.com:8080",
            username: "hbonilla",
            password: "AdamOliver1964",
          },
          reportSource: {
            report: reportUrl,
            parameters: context.parameter,
          },
          parameters: {
            editors: {
              singleSelect: telerikReportViewer.ParameterEditorTypes.COMBO_BOX,
            },
          },
          //"https://demos.telerik.com/reporting/api/reports/",
          //"Telerik.Reporting.Examples.CSharp.ReportCatalog, CSharp.ReportLibrary"
          viewMode: telerikReportViewer.ViewModes.INTERACTIVE,
          scaleMode: telerikReportViewer.ScaleModes.SPECIFIC,
          scale: 1.0,
          sendEmail: { enabled: true },
          parametersAreaVisible: context.overrideParameters ? false : true,

          ready: function() {
            // if (context.overrideParameters) {
            // $("[data-command*='telerik_ReportViewer_toggleParametersArea']")
            //   .parent()
            //   .hide();
            // $(".trv-parameters-area").hide();
            // $(".k-splitbar ").hide();
            // $(".trv-pages-area").css("width", "100%");
            // }
          },
        });
      });
    },
  },
  beforeDestroy() {},
};
